import React, { useEffect, useState } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js'; // Importujemy akcję do aktualizacji aktywnego linku
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';

import { ReactComponent as People } from '../icons/people.svg';
import { ReactComponent as StatusUp } from '../icons/status-up.svg';
import { ReactComponent as Cup } from '../icons/cup.svg';
import { ReactComponent as Trainings } from '../icons/vid-oct.svg';
import { ReactComponent as Teacher } from '../icons/teacher.svg';
import { ReactComponent as DingDong } from '../icons/ding-dong.svg';
import { ReactComponent as Star } from '../icons/star.svg';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { ReactComponent as UserOctagon } from '../icons/user-octagon.svg';
import { ReactComponent as TeamMeLogo } from '../icons/teamme_logo1.svg';

import { useLocation } from 'react-router-dom';
import ProfileModal from './profileModal.jsx';
import SettingsModal from './settingsModal.jsx';

function Menu() {
  const location = useLocation();
  const activeLink = useSelector((state) => state.menu.activeMenuItem); // Pobranie aktywnego linku z Redux  
  const dispatch = useDispatch();

  // Stan dla modali
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);

  const handleLinkClick = (path) => {
    dispatch(setActiveMenuItem(path)); // Aktualizacja aktywnego linku w Redux
  };

   // Wywołanie handleLinkClick przy pierwszym ładowaniu
   useEffect(() => {
    handleLinkClick(location.pathname); // Wywołanie funkcji z aktualną ścieżką
  }, [location.pathname]); // Uruchomienie efektu, gdy zmieni się ścieżka

  const handleLogoutClick = (path) => {
    dispatch(clearTokens()); // Ustawienie tokenu dostępu na pusty
    window.location.reload(); // Odświeżenie strony po wylogowaniu
  };

  const menuItems = [
    { path: '/', icon: People, label: 'Użytkownicy' },
    { path: '/statistics', icon: StatusUp, label: 'Statystyki' },
    { path: '/sports', icon: Cup, label: 'Dyscypliny' },
    { path: '/trainings', icon: Trainings, label: 'Treningi' },
    { path: '/notifications', icon: DingDong, label: 'Powiadomienia' },
    { path: '/opinions', icon: Star, label: 'Opinie' },
    { path: '/users-reports', icon: UserOctagon, label: 'Zgłoszenia użytkowników' },
    { path: '/faq', icon: Teacher, label: 'FAQ' },
    // { path: '/awards', icon: Award, label: 'Prawdopodobny kolejny' },
  ];

  // Funkcja pomocnicza do otwierania ustawień z poziomu profilu (link "Zmień hasło")
  const openSettingsFromProfile = () => {
    setProfileModalOpen(false);
    setSettingsModalOpen(true);
  };

  return (
    <div className="menu">
      <div className="menu-content">
        {/* Logo po lewej stronie */}
        <div className="menu-logo">
          <TeamMeLogo className="menu-icon-without-text" />
        </div>

        {/* Środkowy div z wyśrodkowanymi dziećmi */}
        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              showLabel={false}
              showSpeechBubble={true}
            />
          ))}
        </div>

        {/* Prawy div */}
        <div className="menu-right">
          <MenuButton
            path="#" // Używamy # aby nie zmieniać URL
            currentPath={activeLink}
            onClick={() => setSettingsModalOpen(true)} // Otwieranie modalu ustawień
            icon={Settings}
            label=""
            afterClickingChange={false}
          />
          <MenuButton
            path="#" // Używamy # aby nie zmieniać URL
            currentPath={activeLink}
            onClick={() => setProfileModalOpen(true)} // Otwieranie modalu profilu
            icon={UserSquare}
            label=""
            afterClickingChange={false}
          />
          <MenuButton
            path="/logout"
            currentPath={activeLink}
            onClick={handleLogoutClick}
            icon={Logout}
            label="Wyloguj się"
            iconfirst={false}
            afterClickingChange={false}
            borders="L" // Przykład użycia ramek (L - lewa, R - prawa, B - dolna, T - górna)
          />
        </div>
      </div>

      {/* Renderowanie Modali */}
      {isProfileModalOpen && (
        <ProfileModal 
          onClose={() => setProfileModalOpen(false)} 
          onChangePassword={openSettingsFromProfile}
        />
      )}
      
      {isSettingsModalOpen && (
        <SettingsModal 
          onClose={() => setSettingsModalOpen(false)} 
        />
      )}

    </div>
  );
}

export default Menu;
